/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:47:30
 * @LastEditors: K
 * @LastEditTime: 2022-09-05 11:30:28
 */
import { RecipeCategory } from '../models/recipe'
import { API_PREFIX } from './constant'
import { ContentType, MultiPartFormData, Request } from './request'

export interface CurrentPage {
  current: number
  insuranceCode?: string
  medListCodg?: string
  size: number
  name?: string
}

export interface ProvincePageParams extends CurrentPage {
  hilistCode?: string
  hilistName?: string
}

// 省目录目录
export function getProvincePage(params: ProvincePageParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/insurance/getInsuranceCodeCountryPage`,
    method: 'GET',
    params,
  }
}

export interface PaymentPageParams extends CurrentPage {
  hilistCode?: string
}

// 自付比例目录
export function getPaymentPage(params: PaymentPageParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/insurance/getInsuranceCodeSelfpayPage`,
    method: 'GET',
    params,
  }
}

export interface LimitPageParams extends CurrentPage {
  drugProdname?: string
  hilistCode?: string
}

// 医保限价目录
export function getLimitPage(params: LimitPageParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/insurance/getInsuranceCodeLimitPage`,
    method: 'GET',
    params,
  }
}

export interface uploadExcelParams {
  insuranceCode: string
  file?: any
  code: number
  isIncremental?: number
  listType: string
}
// 目录上传
export function uploadExcel(params: uploadExcelParams): Request {
  return {
    url: `${API_PREFIX}/blade-insurance/insurance/uploadExcel/importData`,
    headers: {
      [ContentType]: MultiPartFormData,
    },
    method: 'POST',
    params,
  }
}

export interface syncInsuranceListParams {
  listType: string
  insuranceCode: string
}
// 目录同步
export function syncInsuranceList(body: syncInsuranceListParams): Request {
  return {
    url: `${API_PREFIX}/blade-insurance/InsuranceCodeEs/syncInsuranceList`,
    method: 'POST',
    body,
  }
}

// 目录变化分析
export function catalogUpdateAnalysis(updateTime: string): Request {
  return {
    url: `${API_PREFIX}/blade-insurance/catalogAnalysis/catalogUpdateAnalysis`,
    method: 'POST',
    body:{
      updateTime
    },
  }
}

// 查询上传进度
export function uploadProgress(body: { ids: Array<number> }): Request {
  return {
    url: `${API_PREFIX}/blade-insurance/asyncTask/searchSyncInsuranceListInRun`,
    method: 'POST',
    body,
  }
}
// 医保目录-疾病设置-表格

export interface getTabelListFnParams {
  current:number
  size:number
  customFlag:number
  listType:number
  specialFlag:number
  status:number
  param:string
}
export function getTabelListFn(params: getTabelListFnParams ): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/diseasecode/customList`,
    method: 'GET',
    params,
  }
}

// 医保目录-疾病设置-新增疾病目录
export interface saveIllnessParams {
  category: number
  diagZjm: string
  icds: number
  listType: number
  id: number
  name: string
}
export function saveIllness(body: saveIllnessParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/insurance/updateDiseaseZjm`,
    method: 'POST',
    body,
  }
}
